export const mainBgColor = '#333333';
export const borderColor = '#737374';